import bodyFont from "../assets/fonts/Jost.woff";
import displayFont from "../assets/fonts/Cormorant.woff";

export { bodyFont, displayFont };

export function invoiceTypography(bodyData, displayData) {
  const bodyFace = bodyData ? `@font-face{font-family:Jost;src:url("${bodyData}") format("woff");font-weight:400;font-style:normal;font-display:swap}` : "";
  const displayFace = displayData ? `@font-face{font-family:Cormorant;src:url("${displayData}") format("woff");font-weight:500;font-style:normal;font-display:swap}` : "";
  return `${bodyFace}${displayFace}body{font-family:Jost,'Trebuchet MS',Arial,sans-serif;line-height:1.5;color:#514536;background:#faf8f4}h1,h2,h3{font-family:Cormorant,Georgia,serif;font-weight:500;letter-spacing:0}th{font-weight:400;background:#f2ede4}td{font-variant-numeric:tabular-nums}`;
}

async function assetData(asset) {
  try {
    const response = await fetch(new URL(asset, window.location.href).href);
    if (!response.ok) return null;
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    });
  } catch { return null; }
}

// Embed assets fetched in the app window; popup asset requests can stall.
export async function printWithTheme(win) {
  if (!win || win.closed) return;
  const images = Array.from(win.document.images);
  const [bodyData, displayData, ...imageData] = await Promise.all([
    assetData(bodyFont), assetData(displayFont),
    ...images.map(image => assetData(image.getAttribute("src"))),
  ]);
  if (win.closed) return;
  images.forEach((image, index) => { if (imageData[index]) image.src = imageData[index]; });
  const style = win.document.createElement("style");
  style.textContent = invoiceTypography(bodyData, displayData);
  win.document.head.appendChild(style);
  const ready = images.map(image => image.decode().catch(() => {}));
  if (win.document.fonts) ready.push(win.document.fonts.load("16px Jost"), win.document.fonts.load("500 24px Cormorant"));
  await Promise.race([
    Promise.all(ready).catch(() => {}),
    new Promise(resolve => setTimeout(resolve, 2000)),
  ]);
  if (!win.closed) { win.focus(); win.print(); }
}
